<template>
  <div>
    <down-time-alerts />
    <migrations-alert v-if="visibleMigrations.length" :migrations="visibleMigrations" />
    <promotion-banners v-if="hasUpgradePromotions" />
    <has-no-card-alert v-if="hasNoCard && !hasUpgradePromotions"/>
    <ticket-alerts v-if="ticketBanners.length > 0" />
      <!-- empty account card -->
    <template v-if="!loadingData">
      <v-row v-if="accountEmpty">
        <v-col cols="12">
          <v-card class="app-card">
            <v-card-text>
              <h3 class="ma-0 text-md-center">
                No Hosting Services
              </h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-row>
      <v-col class="d-block" cols="12" md="12">
        <services-table
          title="Your Hosting Plans"
          :items="allServicesList"
          :filters="filters"
          :search="search"
          :use-billing-per-page-options="true"
          :is-simplified="true"
        >
          <template v-slot:header-actions>
            <g-g-filter
              offset-y
              left
              bottom
              :close-on-content-click="false"
              :items="filterItems"
              @change="filters = $event"
            ></g-g-filter>
            <div class="w-100" style="max-width: 440px">
              <services-search v-model="search" compact />
            </div>
          </template>
        </services-table>
      </v-col>
      <v-col class="d-block" cols="12" md="12">
        <services-table
          title="Shared With Me"
          :items="sharedServicesList"
          :filters="filters"
          :search="search"
          :use-billing-per-page-options="true"
          :is-simplified="true"
          hide-icons
        >
        </services-table>
      </v-col>
      <v-col cols="12">
        <tickets-list
          title="Open Tickets"
          compact
          location="dashboard"
          :exclude-statuses="excludedTicketStatuses"
          :pagination_type="pagination_type"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <affiliates-top-banner />
      </v-col>
    </v-row>
    <two-fa-enable-modal></two-fa-enable-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TicketsList from 'Components/Support/TicketsList'
import TicketAlerts from '@/components/Profile/TicketAlerts'
import HasNoCardAlert from '@/components/Profile/Privacy/HasNoCardAlert'
import AffiliatesTopBanner from '@/components/Affiliates/TopBanner'
import DownTimeAlerts from '@/components/DownTime/DownTimeAlerts'
import PromotionBanners from '@/components/Services/Hosting/Shared/Updowngrade/PromotionBanners'
import MigrationsAlert from '@/components/Migrations/MigrationsAlert'
import ServicesTable from '@/components/Services/Hosting/ServicesPage/ServicesTable'
import GGFilter from '@/components/Elements/GGFilter.vue'
import ServicesSearch from '@/components/Services/Hosting/ServicesPage/ServicesSearch'
import TwoFaEnableModal from '@/components/Modals/TwoFaEnableModal.vue'

export default {
  components: {
    HasNoCardAlert,
    TicketsList,
    AffiliatesTopBanner,
    TicketAlerts,
    DownTimeAlerts,
    PromotionBanners,
    MigrationsAlert,
    ServicesTable,
    GGFilter,
    ServicesSearch,
    TwoFaEnableModal,
  },
  data: () => ({
    pagination_type: [8],
    excludedTicketStatuses: ['Closed', 'Waiting on Customer'],
    acceptedService: ['cpanel', 'whm', 'vserver', 'dserver', 'kvm'],
    search: '',
    // filter settings
    filterItems: [
      { value: 'cpanel', label: 'Shared' },
      { value: 'whm', label: 'Reseller' },
      { value: 'vserver', label: 'VPS' },
      { value: 'dserver', label: 'Dedicated' },
    ],
    // active filters
    filters: [],
  }),
  computed: {
    ...mapGetters({
      services: 'services',
      domains: 'domains',
      servicesPopulated: 'servicesPopulated',
      domainsPopulated: 'domainsPopulated',
      sitebuilders: 'sitebuilders',
      ticketBanners: 'ticketBanners',
      hasNoCard: 'hasNoCard',
      upgradepromotions: 'upgradepromotions',
      migrations: 'migrations/migrations',
      hiddenMigrationAlerts: 'migrations/hiddenMigrationAlerts',
    }),
    visibleMigrations () {
      return this.migrations.filter(migration => {
        return this.hiddenMigrationAlerts.findIndex(hiddenId => {
          return hiddenId == migration.id
        }) === -1
      })
    },
    accountEmpty () {
      return this.domains.length + this.services.length === 0
    },
    hasUpgradePromotions () {
      return this.upgradepromotions.length > 0
    },
    loadingData () {
      return !this.domainsPopulated && !this.servicesPopulated
    },
    servicesList () {
      return this.services
        .filter(service => this.acceptedService.includes(service.type))
        .map((el, index) => ({
          ...el,
          virtualId: `${el.id}-${index}`,
          searchable_name: `${el.domain} ${el.name}`,
          builders: this.sitebuilders.filter((builder) => {
            return el.id === builder.related_service
          })
        }))
    },
    allServicesList () {
      const nonSharedServices = this.servicesList.filter(service => !service.sharedaccount && !service.sharedaccess)
      const sharedAccessServices = this.servicesList.filter(service => service.sharedaccess)

      return nonSharedServices.concat(sharedAccessServices)
    },
    sharedServicesList () {
      return this.servicesList.filter(service => service.sharedaccount)
    }
  },
}
</script>
